var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavigationAndActionLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-445.000000, -2051.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Navigation-and-action/Logout",
    transform: "translate(445.000000, 2051.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0000813,2 C14.6570916,2 16.0001,3.343 16.0001,5 L16.0001,5 L16.0001,31 L3.00001875,31 C1.34300839,31 0,29.657 0,28 L0,28 L0,2 Z M24.3019519,8.8018 L32,16.4998 L24.3019519,24.1978 C23.2389452,23.1358 23.2389452,21.4118 24.3019519,20.3498 L24.3019519,20.3498 L26.7899674,17.8618 L16.9999062,17.8618 L16.9999062,15.1388 L26.7899674,15.1388 L24.3019519,12.6508 C23.2389452,11.5878 23.2389452,9.8638 24.3019519,8.8018 L24.3019519,8.8018 Z M11.5000719,14 C10.1190632,14 9.00005625,15.119 9.00005625,16.5 C9.00005625,17.881 10.1190632,19 11.5000719,19 C12.8810805,19 14.0000875,17.881 14.0000875,16.5 C14.0000875,15.119 12.8810805,14 11.5000719,14 Z",
    id: 181
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationAndActionLogout);
export default __webpack_public_path__ + "static/media/navigation-and-action-logout.19f42cc9.svg";
export { ForwardRef as ReactComponent };